module.exports = __webpack_public_path__ + "static/family-on-couch.4731ba9c.webp";